import { CATEGORY_META } from "@/data/mapConfig";

const HEADERS = ["Company", "Location", "Specialty", "Services", "Address", "City", "State", "ZIP", "Full Address", "Latitude", "Longitude"];

const cell = (v) => {
  const s = v == null ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function downloadProvidersCsv(locations) {
  const rows = locations
    .filter((l) => l.pinned !== false && l.address)
    .sort((a, b) => (a.category + a.company + a.city).localeCompare(b.category + b.company + b.city))
    .map((l) => [
      l.company || l.name,
      l.company ? l.name : "",
      CATEGORY_META[l.category]?.label || l.category,
      l.note || "",
      l.address,
      l.city,
      l.state,
      l.zip,
      `${l.address}, ${l.city}, ${l.state} ${l.zip}`,
      l.lat,
      l.lng,
    ]);
  const csv = [HEADERS, ...rows].map((r) => r.map(cell).join(",")).join("\r\n");
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `GOAT_Provider_Network_${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
  return rows.length;
}
